const { useProjectContext } = require("@contexts/projects");

const ZeroBudgetNotice = () => {
  const { activeProject } = useProjectContext();
  const { name } = activeProject || {};

  return (
    <div className="info-notice">
      <div className="header">
        <span className="margin-right-8">⚠️</span>
        Obra sem orçamento
      </div>

      <p>
        {name ? <>A obra <strong>{name}</strong> está</> : "Esta obra está"} com o orçamento
        zerado, por isso não há fornecedores nem pagamentos para exibir.
      </p>

      <p className="notice-detail">
        Assim que um orçamento for carregado, os dados aparecem aqui.
      </p>
    </div>
  );
};

export default ZeroBudgetNotice;
